module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/qrcode.react/~/prop-types/lib/has.js
// module id = 829
// module chunks = 0